/**
 * llysto - React Native App
 * WebView wrapper for https://prs9.netlify.app/
 *
 * @format
 */

import React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { WebViewScreen } from './src/screens/WebViewScreen';

function App(): React.JSX.Element {
  return (
    <SafeAreaProvider>
      <WebViewScreen />
    </SafeAreaProvider>
  );
}

export default App;
